import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import LastTriage from "../LastTriage/LastTriage";
import AutoCompleteVoiceTriage from "../AutoCompleteVoiceTriage/AutoCompleteVoiceTriage";

const translationPath = "page.triageEmergencyDepartment.";

const TriageInfo = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        marginTop: 3,
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography variant="h6" mb={2}>
        {t(translationPath + "service")}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {t(translationPath + "service_intro")}
        <strong>{t(translationPath + "digital_triage")}</strong>.
        <br />
        {t(translationPath + "service_description")}
        <strong>{t(translationPath + "notify_arrival")}</strong>.
        <br />
        {t(translationPath + "service_instruction")}
      </Typography>
      <Typography variant="h6" mb={2}>
        {t(translationPath + "symptoms_question")}
      </Typography>
      <AutoCompleteVoiceTriage
        label={t("components.medicGuide.search")}
        SearchAsYouTypeParams={(v) => ({ Search: v })}
      />
      <LastTriage />
    </Box>
  );
};
export default TriageInfo;
